<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :center="true"
      title="欠款明细"
      :visible.sync="mxVisible"
      width="700px"
      :before-close="closeEvent"
    >
      <div>
        <el-table :data="list" size="small" @selection-change="handleSelectionChange" style="width: 100%;overflow: auto;" height="400px">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="150px"/>
          <el-table-column prop="deptName" label="欠款门店"/>
          <el-table-column prop="createTime" label="日期" width="150px"/>
          <el-table-column prop="totalPrice" label="订单金额"/>
          <el-table-column prop="amount" label="欠款金额"/>
        </el-table>
      </div>
<!--      <el-button size="small" type="primary" v-if="list.length>0" @click="toRepayment()">还款</el-button>-->
      <div class="btnitems">
        <el-button size="small" type="primary" v-if="list.length>0" @click="toRecharge()">充值还款</el-button>
        <el-button size="small" @click="closeEvent">返回</el-button>
      </div>
    </el-dialog>

    <TabRecharge
      v-if="payVisible"
      :payVisible="payVisible"
      :qk="qk"
      :qkIds="qkIds"
      :member="member"
      :memberCards="memberCards"
      @closeRecharge="closeRecharge"
      @successRecharge="successRecharge"
    />
    <TabRepayment
      v-if="zjVisible"
      :payVisible="zjVisible"
      @fanhui="fanhui"
      @closePay="closePay"
    />
  </div>
</template>

<script>
  import TabRecharge from "./recharge";
  import TabRepayment from "./repayment";

  export default {
    name: "qkinfo",
    components: {
      TabRecharge,
      TabRepayment,
    },
    data() {
      return {
        list: [],
        memberCards:[],
        payVisible: false,
        zjVisible: false,
        qk:'',
        qkIds:[],
        xzList:[],
        member:{}
      };
    },
    props: {
      mxVisible: Boolean,
      memberId: String,
      mxList: Array,
    },
    async created() {
      this.list = this.mxList
      await this.getMember()
      await this.getMemberCards()

    },

    methods: {
      handleSelectionChange(val) {
        this.xzList = val;
      },
      //获取会员信息
      async getMember() {
        let data = {
          memberId: this.memberId
        }
        let res = await this.$get("/sw/getSwMbmber", data);
        this.member = res.member
      },
      //获取会员信息
      async getMemberCards() {
        let res = await this.$get("/sw/getSwMbmberCards", {memberId: this.memberId});
        if (res.memberCards.length>0) {
          this.memberCards = res.memberCards
        }
      },
      closeRecharge() {
        this.payVisible = false
        this.closeEvent()
      },
      successRecharge(item) {
        this.payVisible = false
        this.$emit("successQk",item);
      },

      fanhui() {
        this.zjVisible = false
        this.closeEvent()
      },
      closePay() {
        this.zjVisible = false
      },
      // toRepayment() {
      //   if (this.list.length>0){
      //     let amount=0;
      //     this.list.forEach(item=>{
      //       amount=parseFloat(amount)+parseFloat(item.amount)
      //     })
      //     let mx= this.list[0]
      //     mx.amount=amount.toFixed(2)
      //     this.assetsItem = mx
      //     this.zjVisible = true;
      //   }
      // },

      toRecharge() {
        if (this.memberCards.length<=0){
          this.$message.error("此会员没有会员卡")
          return;
        }
        if (this.xzList.length>0){
          let amount=0;
          this.xzList.forEach(item=>{
            amount=parseFloat(amount)+parseFloat(item.amount)
            this.qkIds.push(item.id)
          })
          this.qk = parseFloat(amount.toFixed(2))
          this.payVisible = true;
        }
      },

      closeEvent() {
        this.$emit("closeQk");
      },
    }
  };
</script>


<style lang="scss" scoped>
  .btnitems{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
  }

</style>
